var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CategoryConsumptionPage',{attrs:{"consumption_category_id":5,"showFuelGasAndDieselChart":false,"colors":{ primary: '#8DA1B9', secondary: '#A6B6C9' },"consumption_category":{ name: 'water', unit: { text: 'Gal.' } }}})}
var staticRenderFns = []

export { render, staticRenderFns }